import React, { useState, } from 'react';
import { Dropdown, Row, Col, List, Button, Menu, Space } from 'antd';
import { UpdateFeedbackStatus } from '../myVitalsFeedbackList/gqls'
import { DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import CustomerPage from './customerItem';
import IHealthPage from './iHealthItem';
import Client from '../../../../lib/gqlClient';
import { message } from 'antd'
const FeedbackDetailsPage = (props, ref) => {

    const [commentList, setCommentList] = useState([{}])
    const [itemsLevel1, setItemsLevel1] = useState([{}])
    const [itemsLevel2, setItemsLevel2] = useState([{}])
    const [selectLevel1, setselectLevel1] = useState("Please Select")
    const [selectLevel2, setselectLevel2] = useState("Please Select")
    React.useEffect(() => {
        showData()
        setItemLevel1Name()
        props.feedbackLevels.map((item, index) => {
            if (item.level === props.tickets.level1) {
                console.log(index, item.subLevel)
                setItemLevel2Name(item.subLevel)
            }
        })
        setselectLevel1(props.tickets.level1)
        setselectLevel2(props.tickets.level2)

    }, [])
    function showData() {
        var totalFileList = [{}]
        props.tickets.attachements.map((item, index) => {
            var name = (item.fileName).toString();
            var url = item.fileUrl;
            var img = '';
            var copywriting = '';
            if (name !== "" || name !== null) {
                if (name.substr(name.length - 3, name.length) === 'zip') {
                    img = <img src={require('../../../../static/img/ic-feedback-zip.png')} style={{ width: '24px', height: '24px' }} />
                    copywriting = '下载附件'
                } else {
                    img = <img src={require('../../../../static/img/ic-feedback-image.png')} style={{ width: '24px', height: '24px' }} />
                    copywriting = '下载图片'
                }
                totalFileList[index] = {
                    name: name,
                    url: url,
                    img: img,
                    copywriting: copywriting
                }
            }
        })
        var list = [{}]
        props.tickets.comment.split('\r\n').map((item, index) => {
            var datas = item.substring(0, item.length - 24)
            var day = moment(item.substring(item.length - 13, item.length) * 1).format("YYYY-MM-DD HH:mm:ss")
            var filesList = [{}]
            var comment = ''
            if (datas.length > 2) {
                var isCustomer = true//当前是否是用户评论
                var data = datas.split('***files***')//裁剪附件
                if (data[0].substring(0, 8) === 'customer') {//用户
                    isCustomer = true
                    comment = data[0].substring(9, data[0].length)
                } else {//客服
                    isCustomer = false
                    comment = data[0].substring(8, data[0].length)
                }
                if (data.length === 2) {
                    //整理当前附件
                    data[1].substring(2, data[1].length - 2).split(',').map((fileItem, fileIndex) => {
                        totalFileList.map((item) => {
                            if (fileItem === item.name) {
                                filesList[fileIndex] = item
                            }
                        })
                    })
                }
            }
            list[index] = {
                isCustomer: isCustomer,
                day: day,
                comment: comment,
                filesList: filesList
            }

        })
        setCommentList(list);
    }

    function setItemLevel1Name() {
        var list = [{}]
        props.feedbackLevels.map((item, index) => {
            list[index] = { key: index, label: item.level }
        })
        setItemsLevel1(list)
    }
    function setItemLevel2Name(level2Items) {
        var list = [{}]
        level2Items.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsLevel2(list)
    }
    const itemsLevel1onClick = ({ key }) => {
        setselectLevel1(itemsLevel1[key].label)
        setselectLevel2("Please Select")
        setItemLevel2Name(props.feedbackLevels[key].subLevel)
    };
    const itemsLevel2onClick = ({ key }) => {
        setselectLevel2(itemsLevel2[key].label)
        setFeedback(itemsLevel2[key].label)
    };
    function setFeedback (selectLevel2){
        props.setLoding(true)
        Client(
            '',
            {
                updateFeedbackStatusId: props.tickets.id,
                status: props.tickets.ticketStatus ,
                level1:selectLevel1,
                level2:selectLevel2
            },
            UpdateFeedbackStatus
        ).then((res) => {
            //刷数据
            props.setLoding(false)
            props.onRefresh()
        
        }).catch(e => {
            message.error('Network timeout, please try again')
            props.setLoding(false)
            props.onRefresh()
        })
    }

    return (
        <div style={{ height: '100%', width: '100%',backgroundColor: 'white', borderRadius: '2px', }}>
             <Row wrap={false} style={{ height: '100%', width: '100%', padding: '20px' }}>
                    <Col flex="1 1 800px" style={{minWidth:'500px', height: '100%', width: '100%', }} >
                        <div style={{ overflowY: 'auto', height: '100%', width: '100%', borderRadius: '10px', border: "1px solid #E9E9E9" }}>
                            <List
                                style={{ margin: '20px', marginTop: '20px', }}
                                itemLayout="vertical"
                                split="true"
                                dataSource={commentList}
                                renderItem={(item, index) => (
                                    <div >
                                        <CustomerPage
                                            isCustomer={item.isCustomer}
                                            day={item.day}
                                            comment={item.comment}
                                            filesList={item.filesList}
                                            index={index} />
                                        <IHealthPage
                                            isCustomer={item.isCustomer}
                                            day={item.day}
                                            comment={item.comment}
                                            filesList={item.filesList} />
                                    </div>
                                )}
                            />
                        </div>

                    </Col>
                    <Col flex="0 1 430px" style={{minWidth:'480px', height: '100%', width: '100%', marginRight:'30px'}}>
                        <div style={{
                            marginLeft: '20px', height: '100%', borderRadius: '10px', border: "1px solid #E9E9E9",
                            paddingTop: '25px', paddingBottom: '50px'
                        }}>
                            <Row >
                                <Col style={Styles.itemLeftStyle}>ticket:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.ticketId}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>User ID:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.userId}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Device Model:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.deviceModel}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Firmware Version:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.fv}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Hardware Version:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.hv}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>App Version:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.appVersion}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Client Phone Device:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.phoneModel}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Phone OS:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.phoneOS}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Level1 name:</Col>
                                <Col style={Styles.itemRightStyle}>
                                    <Dropdown overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }}
                                        overlay={<Menu onClick={itemsLevel1onClick} items={itemsLevel1} />}
                                        style={{ width: '250px', height: '25px', }}>
                                        <Button style={{ padding: '0px', width: '250px', height: '25px', 
                                        color: 'rgba(0, 0, 0, 0.25)' }} >
                                            <Space>
                                                <div style={{
                                                    fontSize: '14px', color: "#000", width: '220px', height: '25px',
                                                    display: 'flex', justifyContent: 'left', alignItems: 'center'
                                                }}>
                                                    {selectLevel1}</div>
                                                <DownOutlined />
                                            </Space>
                                        </Button>
                                    </Dropdown>
                                </Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Level2 name:</Col>
                                <Col style={Styles.itemRightStyle}>
                                    <Dropdown overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }}
                                        overlay={<Menu onClick={itemsLevel2onClick} items={itemsLevel2} />}
                                        style={{ width: '250px', height: '25px', }}>
                                        <Button style={{ padding: '0px', width: '250px', height: '25px',
                                         color: 'rgba(0, 0, 0, 0.25)' }}  >
                                            <Space>
                                                <div style={{
                                                    fontSize: '14px', color: selectLevel2 === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000",
                                                    width: '220px', height: '25px',
                                                    display: 'flex', justifyContent: 'left', alignItems: 'center'
                                                }}>
                                                    {selectLevel2}</div>
                                                <DownOutlined />
                                            </Space>
                                        </Button>
                                    </Dropdown></Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Device Type:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.deviceType}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Create Time:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.createdAt.split('.')[0]}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>App ID:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.appId}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Tag:</Col>
                                <Col style={Styles.itemRightStyle}>--</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Channel:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.channel}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>MAC:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.mac}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}>Customer Source:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.customerSource === "2B" ? 'ToB Customer' : 'ToC Customer'}</Col>
                            </Row>
                            <Row>
                                <Col style={Styles.itemLeftStyle}> Test Account:</Col>
                                <Col style={Styles.itemRightStyle}>{props.tickets.isTest ? 'Yes' : 'No'}</Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
        </div>
    )
}

const Styles = {
    itemLeftStyle: {
        marginLeft: '15px',
        height:'30px',
        width: '160px',
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.85)',
    }, itemRightStyle: {
        marginLeft: '15px',
        height:'30px',
        width: '250px',
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.85)',
    },
}
export default FeedbackDetailsPage;